export default function() {
  return {
    placeholder: 'HH:mm',

    viewHours(modelHours) {
      return {hours: modelHours};
    },

    modelHours(hours) {
      return parseInt(hours, 10);
    },

    filterIncremented(hours) {
      return [hours === 24 ? 0 : hours];
    },

    filterDecremented(hours) {
      return [hours === -1 ? 23 : hours];
    },

    getTimeDisplay(time) {
      if (time) {
        return `${time.hours}:${time.minutes}`;
      }
    },

    adjustNegativeDecrement(hours, belowStep) {
      return belowStep ? hours += 24 : hours;
    }
  };
}
